import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200",
  viewBox: "-40 -40 80 80"
};
const _hoisted_2 = ["ry", "fill"];
const _hoisted_3 = ["ry", "fill"];
const _hoisted_4 = ["ry", "fill"];
const _hoisted_5 = ["ry", "fill"];
const _hoisted_6 = ["font-size", "fill"];
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoRect',
  props: {
    team: null,
    double: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const fontSize = computed(() => props.team.shortName.length > 3 ? 15 : 25);
    const cornerRadius = computed(() => props.rounded ? 15 : 0);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("rect", {
        height: "80",
        width: "80",
        x: "-40",
        y: "-40",
        ry: _unref(cornerRadius),
        fill: __props.team.secondaryColor
      }, null, 8, _hoisted_2), __props.double ? (_openBlock(), _createElementBlock("rect", {
        key: 0,
        height: "74",
        width: "74",
        x: "-37",
        y: "-37",
        ry: _unref(cornerRadius),
        fill: __props.team.primaryColor
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), __props.double ? (_openBlock(), _createElementBlock("rect", {
        key: 1,
        height: "66",
        width: "66",
        x: "-33",
        y: "-33",
        ry: _unref(cornerRadius),
        fill: __props.team.secondaryColor
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("rect", {
        height: "60",
        width: "60",
        x: "-30",
        y: "-30",
        ry: _unref(cornerRadius),
        fill: __props.team.primaryColor
      }, null, 8, _hoisted_5), _createElementVNode("text", {
        y: "3",
        "dominant-baseline": "middle",
        "text-anchor": "middle",
        "font-weight": "bold",
        "font-size": _unref(fontSize),
        fill: __props.team.secondaryColor
      }, _toDisplayString(__props.team.shortName), 9, _hoisted_6)]);
    };
  }
});